import { Alert } from '@zillow/constellation';
import type { RentalApplication } from '../../../graphql/queries';

interface Props {
  application: RentalApplication;
}

export const notAcceptingApplicationsAlertText =
  'The landlord has chosen not to receive applications. You can still submit an application, but the landlord may not respond.';
export const deactivatedAlertText =
  'This listing is no longer active. You can still submit an application, but the landlord may not respond.';

export function ListingAlert({ application }: Props) {
  const { rentalListing, isPrimaryApplicant, invitedDateTime } = application || {};
  const { isActive, isApplicationsAccepted } = rentalListing || {};
  const isInvitedToApplyByLandlord = isPrimaryApplicant && invitedDateTime;
  const isActiveAndNotAcceptingApplications = isActive && !isApplicationsAccepted;
  const isListingAlertShown = (isActiveAndNotAcceptingApplications || !isActive) && !isInvitedToApplyByLandlord;
  return isListingAlertShown ? (
    <Alert
      appearance="warning"
      body={isActiveAndNotAcceptingApplications ? notAcceptingApplicationsAlertText : deactivatedAlertText}
      marginBottom="sm"
    />
  ) : null;
}
